export default __webpack_public_path__ + "static/media/50caf8804cb94f43.41a81c8d27ec4822ed7191b3eb18dc4c.svg";